import Pocketbase, { LocalAuthStore } from 'pocketbase';
import { environment } from 'src/environments/environment';
import { createInjectionToken } from 'ngxtension/create-injection-token';

export const [injectPocketbase] = createInjectionToken(() => new Pocketbase(
  environment.pocketbaseUrl,
  new LocalAuthStore('dabay_auth')
));
